import { render } from "./ModalCalendar.vue?vue&type=template&id=e32a3c5e&scoped=true"
import script from "./ModalCalendar.vue?vue&type=script&lang=js"
export * from "./ModalCalendar.vue?vue&type=script&lang=js"

import "./ModalCalendar.vue?vue&type=style&index=0&id=e32a3c5e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e32a3c5e"]])

export default __exports__